import { AnytimeDocumentPage } from "@/features/anytime/pages/AnytimeDocument";
import React from "react";

const AnytimeDocument = () => {
  return <AnytimeDocumentPage />;
};

export default AnytimeDocument;
